<template>
  <div class="w-100 px-4 text-light px-lg-5">

    <div>
      <h3 class="my-font my-color mt-3">همکاری با زنبورداران</h3>

      <p>
        کوپابی با افتخار میزبان همکاری زنبورداران پرتلاش کشور در سه حوزه‌ی تجاری، علمی و تولید سفارشی است. هدف ما تقویت
        صنعت زنبورداری از طریق ایجاد روابط دو‌سویه و پایدار با اعضای این جامعه است.
      </p>
      <div class="commercial">
        <h4 class="my-font my-color  mt-4">
          🛒
          همکاری تجاری</h4>
        <h6 class="my-font my-color"> خرید محصولات زنبورداری شما</h6>
        <ul class="px-2 " style="list-style: none; align-self: center">
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">عسل طبیعی (دارویی و صادراتی)</p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">گرده گل</p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">بره موم</p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">ژل رویال</p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">زهر زنبور عسل</p>
          </li>

        </ul>


        <p><i class="bi bi-pin-angle-fill text-danger"></i> در ازای این همکاری، خوراک تخصصی کوپابی با قیمت ترجیحی یا
          معامله کالا به کالا در اختیار شما قرار می‌گیرد. </p>
      </div>
      <div class="scientific">
        <h4 class="my-font my-color  mt-4">
          <!--          <i class="bi bi-microscope"></i>-->
          🔬
          همکاری علمی</h4>
        <h6 class="my-font my-color">مشارکت در تحقیقات میدانی</h6>
        <p>زنبوردارانی که مایل به آزمایش خوراک یا داروهای تحقیقاتی کوپابی روی کلنی‌های خود هستند، می‌توانند به‌عنوان
          همکار پژوهشی فعالیت کنند.</p>
        <p>مزایا:</p>
        <ul class="px-2 " style="list-style: none; align-self: center">
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">دریافت نمونه رایگان محصولات تحقیقاتی</p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">آنالیز رایگان عسل یا فرآورده های مورد نیاز زنبوردار</p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">گواهی همکاری در پروژه‌های تحقیقاتی از سوی دانشگاه شهید بهشتی</p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">حضور در وبینارها و نشست‌های علمی اختصاصی</p>
          </li>
        </ul>
      </div>
      <div class="production">
        <h4 class="my-font my-color  mt-4">
          ⚙️
          تولید سفارشی</h4>
        <h6 class="my-font my-color">فرمولاسیون اختصاصی برای نیازهای خاص شما</h6>
        <p>
          کوپابی این امکان را برای زنبورداران فراهم کرده است که محصولات خوراک زنبورعسل موردنیاز خود را
          <b>بر اساس شرایط
            اقلیمی، نژاد زنبور، و هدف پرورشی خاص (تولید عسل، گرده، ژل رویال، زهر و...)</b>
          به‌صورت اختصاصی سفارش دهند.
          <br>
          📦 تولید این محصولات
          <b>با حداقل میزان 450 کیلوگرم</b>
          انجام می‌پذیرد و در فرمولاسیون نهایی، نیاز واقعی کلنی‌ها،
          تجربه زنبوردار، و مشاوره تخصصی کوپابی لحاظ می‌گردد.
        </p>
        <p>
          <br>
          مزایا:
        </p>
        <ul class="px-2 " style="list-style: none; align-self: center">
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">تنظیم فرمول شخصی‌سازی‌شده بر اساس نیاز منطقه</p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">مشاوره تخصصی رایگان پیش از تولید</p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">کاهش ریسک عدم سازگاری خوراک با کلنی</p>
          </li>
          <li class="d-flex">
            <div class="dot_container"><img src="/img/dot.png" width="10px" alt=""></div>
            <p class="px-1 text_start">امکان ثبت برند اختصاصی برای زنبورداران بزرگ</p>
          </li>


        </ul>
      </div>


    </div>
    <div class="text-white">
      <h4 class="my-font my-color  mt-4">
        📝
        ثبت درخواست همکاری</h4>
      <p>لطفاً اطلاعات زیر را تکمیل کنید تا در سریع‌ترین زمان با شما تماس بگیریم:</p>


    </div>
  </div>
  <div class="row justify-content-lg-center">

    <div class="col-lg-6">
      <div class="px-4 text-light">

      </div>
      <div class="main-bg border-radius w-100 p-4">

        <div class="row p-lg-3">
          <div class="col-12">
            <div class="row">
              <p class="mb-4 fw-bold text-success d-none" id="sendSuccess">
                درخواست شما با موفقیت ثبت شد. پس از بررسی، کارشناسان ما با شما ارتباط میگیرند.</p>
              <p class="mb-4 fw-bold text-success d-none" id="sendFail">در ارسال درخواست خطایی رخ داد. لطفا دوباره تلاش
                کنید.</p>
              <div class="col-12 col-lg-6 mb-2">
                <label class="mb-2" for="name">نام و نام خانوادگی</label>
                <input id="name" v-if="user" type="text" class="form-control rounded-0" :value="user.name" required>
                <input id="name" @input="checkUser" v-else type="text" class="form-control rounded-0" required>
              </div>
              <div class="col-12 col-lg-6 mb-2">
                <label class="mb-2" for="mobile">شماره موبایل</label>
                <input v-if="user" id="mobile" type="text" class="form-control rounded-0 en" :value="user?.mobile" disabled>
                <input v-else id="mobile" @input="checkUser" type="text" class="form-control rounded-0 en"  required>
              </div>
              <div class="col-6 mb-2 ">
                <label class="mb-2">استان</label>
                <div>
                  <Multiselect
                      v-model="selectedProvince"
                      :options="provinces"
                      :is-selected="user?.city_id"
                      label="name"
                      mode="single"
                      value-prop="id"
                      track-by="name"
                      placeholder="نام استان را جستجو کنید..."
                      :searchable="true"
                      :close-on-select="true"
                  />
                </div>
                <input type="hidden" id="province_id" @change="" v-model="selectedProvince">
                <div id="city_idHelp" class="form-text error"></div>
                <p class="form-text error m-0" v-for="e in errors.city_id">{{ e }}</p>
              </div>

              <div class="col-6 mb-2 ">
                <label class="mb-2">شهر</label>
                <div>
                  <Multiselect
                      v-model="selectedCity"
                      :options="cities"
                      label="name"
                      mode="single"
                      value-prop="id"
                      track-by="name"
                      placeholder="نام شهر را جستجو کنید..."
                      :searchable="true"
                      :close-on-select="true"
                  />
                </div>
                <input type="hidden" id="city_id" v-model="selectedCity">
                <div id="city_idHelp" class="form-text error"></div>
                <p class="form-text error m-0" v-for="e in errors.city_id">{{ e }}</p>
              </div>


            </div>
          </div>
          <!--      گزینه های قابل ارائه:                                               زهر-->

          <div class="col-12">
            <label class="mb-2" for="">نوع همکاری</label>

            <div class="d-flex flex-wrap justify-content-between">
              <div class="d-flex justify-content-start cursor-pointer ">
                <p class="text-nowrap checkbox-label" @click="checkboxToggle('commercial')">تجاری</p>
                <div id="commercial" class="ms-1 check-box-dark" :check-box-checked="0"
                     @click="checkboxToggle('commercial')">
                  <i class="bi bi-check-lg opacity-0"></i>
                </div>
              </div>
              <div class="d-flex justify-content-start cursor-pointer ">
                <p class="text-nowrap checkbox-label" @click="checkboxToggle('scientific')">علمی</p>
                <div id="scientific" class="ms-1 check-box-dark" :check-box-checked="0"
                     @click="checkboxToggle('scientific')">
                  <i class="bi bi-check-lg opacity-0"></i>
                </div>
              </div>
              <div class="d-flex justify-content-start cursor-pointer ">
                <p class="text-nowrap checkbox-label" @click="checkboxToggle('custom_production')">تولید سفارشی</p>
                <div id="custom_production" class="ms-1 check-box-dark" :check-box-checked="0"
                     @click="checkboxToggle('custom_production')">
                  <i class="bi bi-check-lg opacity-0"></i>
                </div>
              </div>
              <!--            <div class="d-flex justify-content-start cursor-pointer ">-->
              <!--              <p class="text-nowrap checkbox-label" @click="checkboxToggle('ch-4')">هر سه</p>-->
              <!--              <div id="ch-4" class="ms-1 check-box-dark" :check-box-checked="0" @click="checkboxToggle('ch-4')">-->
              <!--                <i class="bi bi-check-lg opacity-0"></i>-->
              <!--              </div>-->
              <!--            </div>-->

            </div>
          </div>

          <div class="col-12 ">
            <label class="mb-2" for="">گزینه های قابل ارائه</label>

            <div class="d-flex flex-wrap justify-content-between">
              <div class="d-flex justify-content-start cursor-pointer ">
                <p class="text-nowrap checkbox-label" @click="checkboxToggle('honey')">عسل</p>
                <div id="honey" class="ms-1 check-box-dark" :check-box-checked="0" @click="checkboxToggle('honey')">
                  <i class="bi bi-check-lg opacity-0"></i>
                </div>
              </div>
              <div class="d-flex justify-content-start cursor-pointer ">
                <p class="text-nowrap checkbox-label" @click="checkboxToggle('pollen')"> گرده گل</p>
                <div id="pollen" class="ms-1 check-box-dark" :check-box-checked="0" @click="checkboxToggle('pollen')">
                  <i class="bi bi-check-lg opacity-0"></i>
                </div>
              </div>
              <div class="d-flex justify-content-start cursor-pointer ">
                <p class="text-nowrap checkbox-label" @click="checkboxToggle('propolis')">بره‌موم</p>
                <div id="propolis" class="ms-1 check-box-dark" :check-box-checked="0"
                     @click="checkboxToggle('propolis')">
                  <i class="bi bi-check-lg opacity-0"></i>
                </div>
              </div>
              <div class="d-flex justify-content-start cursor-pointer ">
                <p class="text-nowrap checkbox-label" @click="checkboxToggle('royal_jelly')"> ژل رویال </p>
                <div id="royal_jelly" class="ms-1 check-box-dark" :check-box-checked="0"
                     @click="checkboxToggle('royal_jelly')">
                  <i class="bi bi-check-lg opacity-0"></i>
                </div>
              </div>
              <div class="d-flex justify-content-start cursor-pointer ">
                <p class="text-nowrap checkbox-label" @click="checkboxToggle('bee_venom')">زهر</p>
                <div id="bee_venom" class="ms-1 check-box-dark" :check-box-checked="0"
                     @click="checkboxToggle('bee_venom')">
                  <i class="bi bi-check-lg opacity-0"></i>
                </div>
              </div>

            </div>
          </div>
          <div class="col-12 mb-3">
            <label class="mb-2" for="description">توضیحات تکمیلی</label>
            <textarea @input="checkUser"  id="description" type="text" class="form-control rounded-0"></textarea>
          </div>
          <div class="col-12">
            <label class="mb-2" for="">آپلود فایل مستندات:
              <br>
              (پروانه زنبورداری، تصویر کندو، محصول، گواهی ارگانیک ، سابقه کاری
              ،عکس محصول، گزارش آنالیز قبلی )</label>
            <div style="border-radius: 16px">
              <drop-zone id="dropZone1" :title="'مستندات'" v-model:files="selectedFiles" :index="1" :has-error="img1Error" required/>


            </div>

          </div>

          <div class="text-center col-lg-12 mt-3">
            <!--            <button class="btn-black-rect">ثبت</button>-->
            <button class="btn-black-rect" @click="storeRequest">ثبت</button>
<!--            <button v-if="!user?.id" class="btn-black-rect" @click="showModal('collaboration')">modal</button>-->
          </div>
        </div>


      </div>
    </div>
  </div>

</template>

<script>
import {useStore} from "vuex";
import dropZone from "@/components/DropZone2";
import {computed, onMounted, ref, watch} from "vue";
import Multiselect from '@vueform/multiselect'  //npm install @vueform/multiselect
import '@vueform/multiselect/themes/default.css'
import Loader from "@/components/Loader2.vue"


export default {
  name: "Collaboration",
  components: {dropZone, Multiselect, Loader},
  setup() {
    const store = useStore();
    const serverUrl = store.state.serverUrl;
    const img1Error = ref(false);
    const isLoading = ref(false);
    const errors = ref([]);
    const user = computed(() => JSON.parse(localStorage.getItem('user')));
    const mobile = ref();
    const message = ref();
    const name = ref();
    const email = ref();
    const city_id = ref();
    const emptyFieldsCount = ref();
    const provinces = ref([]);
    const cities = ref([]);
    const selectedCity = ref();
    const selectedProvince = ref()
    const selectedFiles = ref([])


    const setForm = async (form) => {
      localStorage.setItem('form', form);
      validate();
    }
    const validate = () => {
      mobile.value = document.getElementById('mobile').value;
      errors.value = [];
      errors.value['mobile'] = [];
      emptyFieldsCount.value = 0;
      let req = document.querySelectorAll('[required]');
      req.forEach((element) => {
        if (element.value === "") {
          element.classList.add('hasError');
          // element.nextSibling.innerHTML = "فیلد اجباری";
          emptyFieldsCount.value++;
        } else {
          element.classList.remove('hasError');
          // element.nextSibling.innerHTML = "";
        }
      });
      if (document.querySelector('#img1')?.classList.contains('hasError')) {
        img1Error.value = true;
      } else {
        img1Error.value = false;
      }
      if (mobile.value && mobile.value?.length !== 11) {
        errors.value['mobile'].push('شماره موبایل باید 11 رقم باشد');
        document.getElementById('messageMobile').classList.add('hasError');
        emptyFieldsCount.value++;
      }
      if (mobile.value && !mobile.value?.startsWith('09')) {
        errors.value['mobile'].push('شماره موبایل باید با 09 شروع شود');
        document.getElementById('messageMobile').classList.add('hasError');
        emptyFieldsCount.value++;
      }
      if (!localStorage.getItem('user') && emptyFieldsCount.value === 0) {
        document.getElementById('modal-btn-h').click();
      }
    }
    const showModal = async (type) => {
      await setForm(type);
      validate();
      if (emptyFieldsCount.value === 0) {
        document.getElementById('modal-btn-h').click();
      }
    }
    const getProvinces = async () => {
      try {
        await store.dispatch('getProvinces');
        provinces.value = store.state.provinces;

      } catch (error) {
        console.error('API call failed:', error);
      }
    };
    const getCities = async (id) => {
      try {
        await store.dispatch('getCities', id);
        cities.value = store.state.cities;
      } catch (error) {
        console.error('API call failed:', error);
      }
    };

    const checkboxToggle = (id) => {
      let x = document.getElementById(id);
      let y = x.getAttribute('check-box-checked') == 0 ? 1 : 0;
      if (y === 1) {
        x.firstChild.classList.remove('opacity-0');
      } else {
        x.firstChild.classList.add('opacity-0');
      }
      document.getElementById(id).setAttribute('check-box-checked', y);
    }
    const storeRequest = async () => {
      try {
        document.getElementById('sendSuccess')?.classList.add('d-none');
        document.getElementById('sendFail')?.classList.add('d-none');
        validate();
        if (user.value && emptyFieldsCount.value === 0) {
          if (!selectedFiles.value.length) {
            alert('Please upload at least one image.')
            return
          }

          const formData = new FormData()

          // ✅ Append each file
          selectedFiles.value.forEach((file, i) => {
            formData.append('images[]', file)
          })

          formData.append('user_id', user.value.id);
          formData.append('commercial', document.getElementById('commercial').getAttribute('check-box-checked'));
          formData.append('scientific', document.getElementById('scientific').getAttribute('check-box-checked'));
          formData.append('custom_production', document.getElementById('custom_production').getAttribute('check-box-checked'));
          formData.append('honey', document.getElementById('honey').getAttribute('check-box-checked'));
          formData.append('pollen', document.getElementById('pollen').getAttribute('check-box-checked'));
          formData.append('propolis', document.getElementById('propolis').getAttribute('check-box-checked'));
          formData.append('royal_jelly', document.getElementById('royal_jelly').getAttribute('check-box-checked'));
          formData.append('bee_venom', document.getElementById('bee_venom').getAttribute('check-box-checked'));
          formData.append('description', document.getElementById('description').getAttribute('check-box-checked'));

          await fetch(serverUrl + '/api/collab/store', {
            method: 'POST',
            body: formData,
          })
              .then(async (response) => {
                if (response.status === 201) {
                  document.getElementById('sendSuccess')?.classList.remove('d-none');
                } else {
                  document.getElementById('sendFail')?.classList.remove('d-none');
                  const errorData = await response.json().catch(() => ({}));
                  throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
                }
              })
              .catch((error) => {
                console.error(error.message);
              });
        }
      } catch (error) {
        console.error('API call failed:', error);
        document.getElementById('sendFail').classList.remove('d-none');
      }
    }

    onMounted(() => {
      // localStorage.removeItem('user');
      console.log(user.value)
      getProvinces();
      document.querySelectorAll('.multiselect-search')?.forEach((e) => {
        e.setAttribute('autocomplete', 'off');
      })
    })
    watch(selectedProvince, (newValue, oldValue) => {
      getCities(newValue);
    })

    const checkUser = ()=>{
      setForm('collaboration');
      if (!localStorage.getItem('user')) {
        document.getElementById('modal-btn-h').click();
      }
    }
    return {
      checkUser,
      storeRequest,
      checkboxToggle, selectedProvince, getProvinces,
      provinces,
      cities, selectedCity,
      getCities,
      store,
      serverUrl,
      isLoading,
      errors,
      setForm,
      user,
      mobile,
      message,
      name,
      email,
      city_id,
      validate,
      emptyFieldsCount,
      showModal, img1Error,selectedFiles
    }
  }
}
</script>

<style scoped>
li p {
  font-size: 14px;
}

:deep(.multiselect-search) {
  width: 100% !important;
  height: 37.6px !important;
  border: none !important;
  border-radius: 0 !important;
}

:deep(.multiselect,.multiselect-wrapper) {
  width: 100% !important;
  border-radius: 0 !important;
  height: 37.6px !important;
  padding-left: 10px !important;

}

:deep(.multiselect-single-label) {
  width: 100% !important;
  right: 0 !important;
  left: unset !important;
  height: 100% !important;
}
</style>